import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Trophy, Gamepad2, Users, Zap } from 'lucide-react';
const features = [{
  icon: Trophy,
  title: 'Recompensas Exclusivas',
  description: 'Recibe promociones, descuentos e invitaciones exclusivas.',
  color: 'text-yellow-400',
  border: 'group-hover:border-yellow-400/50'
}, {
  icon: Gamepad2,
  title: 'Torneos Épicos',
  description: 'Compite en eventos oficiales de la Asociación Ecuatoriana de Deportes Electrónicos.',
  color: 'text-gaming-cyan',
  border: 'group-hover:border-gaming-cyan/50'
}, {
  icon: Users,
  title: 'Comunidad Gamer',
  description: 'Conecta con jugadores de todo Ecuador, forma equipos y encuentra rivales de tu nivel.',
  color: 'text-gaming-purple',
  border: 'group-hover:border-gaming-purple/50'
}, {
  icon: Zap,
  title: 'Contenido Premium',
  description: 'Trucos pro de juegos y contenido especial.',
  color: 'text-gaming-accent',
  border: 'group-hover:border-gaming-accent/50'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 50
    }
  }
};
export function Features() {
  return <section className="py-24 bg-gaming-dark relative" data-id="element-34">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-35">
        <div className="text-center mb-16" data-id="element-36">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-white uppercase tracking-wider" data-id="element-37">
            Características{' '}
            <span className="text-gaming-cyan" data-id="element-38">Legendarias</span>
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-gaming-purple to-gaming-cyan mx-auto rounded-full" data-id="element-39"></div>
        </div>

        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-40">
          {features.map((feature, index) => <motion.div key={index} variants={item} className={`group relative bg-gaming-card p-8 rounded-xl border border-white/5 ${feature.border} transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_0_30px_rgba(0,0,0,0.5)]`} data-id="element-41">
              <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-xl" data-id="element-42"></div>

              <div className={`w-14 h-14 bg-gaming-dark rounded-lg flex items-center justify-center mb-6 border border-white/10 group-hover:scale-110 transition-transform duration-300`} data-id="element-43">
                <feature.icon className={`w-8 h-8 ${feature.color}`} data-id="element-44" />
              </div>

              <h3 className="text-xl font-bold mb-3 text-white group-hover:text-gaming-cyan transition-colors" data-id="element-45">
                {feature.title}
              </h3>

              <p className="text-gray-400 leading-relaxed text-sm" data-id="element-46">
                {feature.description}
              </p>

              {/* Decorative corner accents */}
              <div className="absolute top-0 right-0 w-2 h-2 border-t border-r border-white/20 rounded-tr-sm group-hover:border-gaming-cyan transition-colors" data-id="element-47"></div>
              <div className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-white/20 rounded-bl-sm group-hover:border-gaming-purple transition-colors" data-id="element-48"></div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}